module.exports = __webpack_public_path__ + "static/media/DigitalRevisorLogo.18cc5558.png";